import axios from 'axios'
import pageAdminCompanyEdit from '../common/pages/admin/company/edit'
import pageAdminPrivacyPolicyEdit from '../common/pages/admin/privacy_policy/edit'
import pageAdminSolicitationPolicyEdit from '../common/pages/admin/solicitation_policy/edit'
import pageAdminTopEdit from '../common/pages/admin/top/edit'
import pageAdmincustomerEdit from '../common/pages/admin/customer/edit'
import pageAdminOtherPolicyEdit from '../common/pages/admin/other_policy/edit'
import pageAdminNetInsurancerEdit from '../common/pages/admin/net_insurance/edit'
import pageAdminInsurancerEdit from '../common/pages/admin/insurance/edit'
import pageAdminStaffEdit from '../common/pages/admin/staff/edit'
import pageAdminNewsEdit from '../common/pages/admin/news/edit'
import pageAdminSalesPolicyEdit from '../common/pages/admin/sales_policy/edit'
import pageAdminRecruitEdit from '../common/pages/admin/recruit/edit'
import pageAdminAccidentEdit from '../common/pages/admin/accident/edit'
import pageAdminCustomerVoiceEdit from '../common/pages/admin/customer_voice/edit'
import pageAdminContactEdit from '../common/pages/admin/contact/edit'

// 設定
const el = document.querySelector('meta[name="csrf-token"]')
axios.defaults.headers.common['X-CSRF-TOKEN'] = el ? el.getAttribute('content') : null

// ページ別
const pages = {
    admin: {
        privacy_policy: {
            edit: pageAdminPrivacyPolicyEdit
        },
        solicitation_policy: {
            edit: pageAdminSolicitationPolicyEdit
        },
        company: {
            edit: pageAdminCompanyEdit
        },
        top: {
            edit: pageAdminTopEdit
        },
        customer: {
            edit: pageAdmincustomerEdit
        },
        otherPolicy: {
            edit: pageAdminOtherPolicyEdit
        },
        net_insurance: {
            edit: pageAdminNetInsurancerEdit
        },
        staff: {
            edit: pageAdminStaffEdit
        },
        insurance: {
            edit: pageAdminInsurancerEdit
        },
        news: {
            edit: pageAdminNewsEdit
        },
        sales_policy: {
            edit: pageAdminSalesPolicyEdit
        },
        recruit: {
            edit: pageAdminRecruitEdit
        },
        accident: {
            edit: pageAdminAccidentEdit
        },
        customer_voice: {
            edit: pageAdminCustomerVoiceEdit
        },
        contact: {
            edit: pageAdminContactEdit
        }
    },
}
window.App = {pages}
